module.exports = __webpack_public_path__ + "static/media/Sakshi_Mahajan.bc09298d.jpg";